
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {BaiduMap, BmMarker, BmLabel, BmOverlay} from 'vue-baidu-map'
import { mapState } from 'vuex'

export default {
name: 'mapPosition',
props: [],
components: {
XHeader,
Group,
Cell,
BaiduMap,
BmMarker,
BmLabel,
BmOverlay
},
data () {
return {
title: this.$route.params.title,
flowProcedureId: this.$route.params.flowProcedureId,
procedureId: this.$route.params.procedureId,
procedureInfo: [
{
title: '办理地址',
content: ''
},
{
title: '联系老师',
content: ''
},
{
title: '联系电话',
content: ''
},
{
title: '办理日期',
content: ''
}
],
zoom: 16,
center: '北京',
contactInfo: {
position: ''
},
isMap: false,
isShowMap: false,
mapStyle: {
styleJson: [
{
'featureType': 'all',
'elementType': 'geometry',
'stylers': {
'hue': '#007fff',
'saturation': 89
}
},
{
'featureType': 'water',
'elementType': 'all',
'stylers': {
'color': '#ffffff'
}
}
]
}
}
},
computed: {
...mapState({
studentId: state => state.userInfo.id,
flowId: state => state.flowInfo.flowId
})
},
created () {},
mounted () {
this.$vux.loading.show({
text: '加载中,请稍候'
})
this.getContactInfo()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
draw ({el, BMap, map}) {
this.getContactInfo().then(() => {
const pixel = map.pointToOverlayPixel(new BMap.Point(this.contactInfo.position.lng, this.contactInfo.position.lat))
el.style.left = pixel.x - 82 + 'px'
el.style.top = pixel.y + 'px'
})
},
getContactInfo () {
let params = {
studentId: this.studentId,
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId,
'flowBean.isInFlow': 1
}
return new Promise((resolve, reject) => {
this.$api.get('/dataManagement/getDataManagementList', params,
r => {
this.$vux.loading.hide()
let data = r.data
let procedureInfo = {
address: data[0].flowProcedureBean.address,
contact: data[0].flowProcedureBean.contact,
contactNumber: data[0].flowProcedureBean.contactNumber,
date: data[0].flowProcedureBean.startDate + ' 至 ' + data[0].flowProcedureBean.endDate
}
let arr = []
for (let i in procedureInfo) {
arr.push(procedureInfo[i])
}
for (let j = 0; j < arr.length; j++) {
this.procedureInfo[j].content = arr[j]
}

this.isShowMap = Boolean(data[0].flowProcedureBean.position)
if (data[0].flowProcedureBean.position) {
let arrLen = data[0].flowProcedureBean.position.split(',').length
if (arrLen === 1) {
this.center = data[0].flowProcedureBean.position
} else if (arrLen === 2) {
let arr = data[0].flowProcedureBean.position.split(',')
let position = {
lng: parseFloat(arr[1]),
lat: parseFloat(arr[0])
}
this.center = position
this.contactInfo.position = position
}
}
resolve()

},
err => {
this.$vux.toast.text(err.message, 'top')
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/record/map.vue